/* @flow */

import React from 'react';
import { useGlamor } from 'app/glamor';

type Props = {
  classes: Object,
  discount: number,
};

function DiscountPromo({
  classes,
  discount,
}: Props) {
  return (
    <div className={classes.promotion}>
      <div className={classes.promotionInner}>
        <div className={classes.discountIcon}>
          <span className="ion-ribbon-a" />
        </div>
        <div className={classes.discountDetails}>
          <div className={classes.discountValue}>{discount}%</div>
          <div className={classes.discountText}>DISCOUNT</div>
        </div>
      </div>
    </div>
  );
}

function applyStyles(theme) {
  return {
    discountDetails: {
      borderColor: theme.color.basis2,
      borderStyle: 'solid',
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderTopWidth: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: theme.fontWeight.demiBold,
      justifyContent: 'center',
      paddingTop: 1,
      paddingRight: 5,
      paddingBottom: 1,
      paddingLeft: 3,
    },
    discountIcon: {
      alignItems: 'center',
      color: theme.color.basis2,
      display: 'flex',
      fontSize: '2em',
      marginTop: -3,
      marginBottom: -3,
    },
    discountValue: {
      fontSize: '0.9em',
      textAlign: 'center',
    },
    discountText: {
      fontSize: '0.5em',
    },
    promotion: {
      marginBottom: theme.spacing.tiny,
      [theme.mediaQuery.tabletPortraitAndUp]: {
        bottom: 0,
        marginBottom: 0,
        paddingTop: 2,
        paddingRight: 5,
        position: 'absolute',
        right: '100%',
        top: 0,
      },
    },
    promotionInner: {
      alignItems: 'stretch',
      display: 'flex',
      justifyContent: 'center',
      lineHeight: 1,
      [theme.mediaQuery.mobileOnly]: {
        justifyContent: 'flex-start',
      },
    },
  };
}

export default useGlamor(applyStyles)(DiscountPromo);
